<div class="row gx-3 gy-3 pb-3 search-bar-container mt-0 px-3">
  <div class="col-12 radio-buttons">
    <label [for]="'RoundTrip'+id">
      <input [(ngModel)]="trip_type" type="radio" [name]="'type'+id" [id]="'RoundTrip'+id" value="RoundTrip">
      <span>
        Round-trip
      </span>
    </label>
    <label [for]="'OneWay'+id">
      <input [(ngModel)]="trip_type" type="radio" [id]="'OneWay'+id" [name]="'type'+id" value="OneWay">
      <span>
        One-way
      </span>
    </label>
    <label [for]="'Multi'+id">
      <input [(ngModel)]="trip_type" [id]="'Multi'+id" type="radio" [name]="'type'+id" value="Multi">
      <span>
        Multi-destination
      </span>
    </label>
  </div>
  <app-one-way-form *ngIf="trip_type=='OneWay'" (onsearch)="search($event)"></app-one-way-form>
  <app-round-trip-form *ngIf="trip_type=='RoundTrip'" (onsearch)="search($event)"></app-round-trip-form>
  <app-multi-destination-form *ngIf="trip_type=='Multi'" (onsearch)="search($event)"></app-multi-destination-form>
</div>